import React from 'react';
import {Header} from './header';
import {Footer} from './footer';
import './theme.css';

export const Theme = (props) => {
    const {children} = props;
    return (
        <>
            <Header />
            {children}
            <Footer />
        </>
    );
};